import { tooltipBaseStyle, tooltipArrow, tooltipBody } from './styles';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { TooltipProps } from './';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import * as meta from '../../meta-data.json';

export const overrides = (props: TooltipProps) => {
	const HTMLAttrs = getHTMLAttributes(props);
	return {
		Inner: {
			props: {
				'data-epo': `epo-tooltip-${meta.version}`,
				part: `epo-tooltip-${meta.version}`,
				className: props.className,
				...HTMLAttrs.dataProps,
				...HTMLAttrs.ariaProps,
				...getBaseCustomProps(props),
				id: props.id,
				onHover: (e: any) => { e.stopPropagation() }
			},
			style: ({ $theme }: any) => {
				return {
					...tooltipBaseStyle($theme, props),
				};
			},
		},
		Body: {
			style: ({ $theme }: any) => {
				return { ...tooltipBody($theme) };
			},
		},
		Arrow: {
			style: ({ $theme }: any) => {
				return {
					...tooltipArrow($theme),
				};
			},
		},
	};
};
